import React, { useState, useEffect } from "react";
import axios from "axios";
import Sales_Nfsa_Non_Nfsa from './Sales_Nfsa_Non_Nfsa';

const Sales_NFSA_Non_NFSA_Int = () => {
  const currentMonth = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();

  const [months, setMonths] = useState([]);
  const [years, setYears] = useState([]);

  const [selectedMonth, setSelectedMonth] = useState(currentMonth.toString());
  const [selectedYear, setSelectedYear] = useState(currentYear.toString());
  const [nfsaType, setNfsaType] = useState("N");

  const [submitted, setSubmitted] = useState(false);
  const [submitMonth, setSubmitMonth] = useState("");
  const [submitYear, setSubmitYear] = useState("");
  const [submitType, setSubmitType] = useState("");

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_URL_SALE}/api/SalesNfsa/months`)
      .then(response => setMonths(response.data))
      .catch(error => console.error("Error fetching months:", error));

    const yearList = [];
    for (let y = 2019; y <= currentYear; y++) yearList.push(y);
    setYears(yearList);
  }, [currentYear]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitMonth(selectedMonth);
    setSubmitYear(selectedYear);
    setSubmitType(nfsaType);
    setSubmitted(true);
  };

  const handleBack = () => {
    setSelectedMonth(currentMonth.toString());
    setSelectedYear(currentYear.toString());
    setNfsaType("N");
    setSubmitted(false);
  };

  return (
    <div >
      <div align="center">
        <form onSubmit={handleSubmit} style={{ width: "60%" }}>
          <table align="center">
            <thead>
              <tr className="tableheader">
                <th colSpan={6} >
                  NFSA / Non-NFSA Sale Abstract
                </th>
              </tr>
            </thead>
            <tbody>
              <tr >
                <td >Allotted Month</td>
                <td>
                  <select
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                    required
                  >
                    {months.map((m) => (
                      <option key={m.month} value={m.month}>{m.name}</option>
                    ))}
                  </select>
                </td>

                <td >Allotted Year</td>
                <td>
                  <select
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    required
                  >
                    {years.map((y) => (
                      <option key={y} value={y}>{y}</option>
                    ))}
                  </select>
                </td>

                <td >Type</td>
                <td>
                  <select
                    value={nfsaType}
                    onChange={(e) => setNfsaType(e.target.value)}
                  >
                    <option value="N">NFSA</option>
                    <option value="S">Non-NFSA</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td colSpan={6} style={{ textAlign: "center", padding: "10px" }}>
                  <button className="button" type="submit" >
                    Submit
                  </button>
                  <button className="button" type="button" onClick={handleBack} >
                    Back
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </form>

        {submitted && (
          <div style={{ marginTop: "20px", width: "90%" }}>
            <Sales_Nfsa_Non_Nfsa
              nfsaType={submitType}
              month={submitMonth}
              year={submitYear}
              fetchTrigger={submitted}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Sales_NFSA_Non_NFSA_Int;
